import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import UserMenu from './UserMenu';
import StatusSelect from "./StatusSelect";
import LanguageSwitcher from "./LanguageSwitcher";

const styles = {
    wrapper: {
        zIndex: 10,
        position: 'fixed',
        width: '100%',
        top: 0,
        left: 0,
        WebkitBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        MozBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        boxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        padding: '10px 0',
        backgroundColor: '#fff',
    },
    headerContainer: {
        display: 'flex',
        gap: '10px',
        padding: '0 15px',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginLeft: '60px'
    },
    brand: {
        flexBasis: '60px',
        width: '60px',
        height: '100%',
        backgroundColor: '#043e5c',
    },
    title: {
        flexGrow: 1,
        color: 'rgb(4, 62, 92)',
        fontSize: '18px',
        display: 'inline-block',
        textAlign: 'center',
    },
};

const Header = (props) => {
    const {user, company} = props;
    return (
        <div style={styles.wrapper}>
            <div style={styles.headerContainer}>
                <h1 style={styles.title}>
                    {company.name}
                </h1>
                <div style={{display: 'flex', gap:'10px'}}>
                    <LanguageSwitcher user={user} />
                    <StatusSelect user={user}/>
                    <UserMenu user={user}/>
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
};

export default Radium(Header);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/index.jsx